import React from 'react';
import * as PlayingCards from '@letele/playing-cards';

function PlayingCard({ card = null, className = '', isBack = false }) {
    const CardComponent = isBack ? PlayingCards.B2 : PlayingCards[card?.component];

    if (!CardComponent) {
        return null;
    }

    return <CardComponent aria-hidden="true" className={className} focusable="false" />;
}

export default PlayingCard;
